module.exports = __webpack_public_path__ + "img/orange_120.9e68885c.png";